document.addEventListener("DOMContentLoaded", function() {
  var termsLink = document.querySelector(".js-terms-popup");
  var popup = document.querySelector(".ocm-terms-popup");
  var overlay = document.querySelector(".ocm-terms-popup__overlay");
  var closeBtn = document.querySelector(".js-close-popup");

  function openPopup(e) {
    e.preventDefault();
    popup.classList.add("_is-open");
  }

  function closePopup(e) {
    e.preventDefault();
    popup.classList.remove("_is-open");
  }

  if (termsLink) {
    termsLink.addEventListener("click", openPopup);
  }

  if (overlay) {
    overlay.addEventListener("click", function(e) {
      if (e.target === overlay) {
        closePopup(e);
      }
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", closePopup);
  }
});


